/**
 * 行业专区 - 行业破圈
 */

import {get, post, postJson, deleteApi,imagePost} from '../axios'

const RESOURCE_BASE_PATH = '/jd-yusms'

// 获取行业热点列表 yusms/industryBreakCircle
export const gethotspotList = p => get(`/industry-break/hotspot/list`, p);

// 获取行业破圈解法列表 yusms/industryBreakCircle
export const getSolutionList = p => get(`/industry-break/solution/list`, p);

// 点击数据新增次数
export const getClickData = p => get(`/industry-break/click-data`, p);

// 跳转京获客
export const toJHK = p => get(`/hd/redirect`, p);

// 获取用户菜单列表
export const getSeller = p => get(`/seller/current`, p);